import * as constants from '../../constants';
import textButton from '../../shared-ui/text-button';

export default function( data, eventEmitter ) {
  const text = 'START';
  const bgColour = constants.green;
  const width = 260;
  const height = 70;

  const btn = textButton({ text, bgColour, width, height });
  btn.label.style.font = '24px Open Sans, Arial';
  btn.label.style.letterSpacing = 2;

  update();

  function update() {
    const enabled = data.some(elm => elm.selected);
    btn.interactive = enabled;
    btn.alpha = enabled ? 1 : 0.3;
  }

  eventEmitter.on('update-selection', update);

  return btn;
};
